export const MODAL_ACTION_CREATE = 'MODAL_ACTION_CREATE';
export const MODAL_ACTION_UPDATE = 'MODAL_ACTION_UPDATE';
